import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Selector satuan: satuan dasar + satuan kemasan (packs) barang. Dipakai semua form transaksi.
export function UnitSelect({ product, value, onChange, testid }) {
  if (!product) return <div className="text-xs font-mono text-slate-500 px-2">-</div>;
  const opts = [product.unit, ...(product.packs || []).map((pk) => pk.unit)];
  if (opts.length <= 1) return <div className="text-xs font-mono text-slate-500 px-2">{product.unit}</div>;
  return (
    <Select value={value || product.unit} onValueChange={onChange}>
      <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{opts.map((u) => <SelectItem key={u} value={u}>{u}</SelectItem>)}</SelectContent>
    </Select>
  );
}

// Key stabil untuk baris form transaksi (menghindari array index sebagai key)
export const rid = () => Math.random().toString(36).slice(2, 10);
